import PropTypes from "prop-types";
import { Navigate, useSearchParams } from "react-router-dom";
// components
import LoadingScreen from "../components/loading-screen";
//
import { useAuthContext } from "../hooks/useAuthContext";
import { PATHS } from "../routes/paths";
import { useIsMaintenance } from "src/hooks/useIsMaintenance";
import { getPathAfterLogin } from "src/utils/getPathAfterLogin";

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();
  const { isWebMaintenance } = useIsMaintenance();
  const [searchParams] = useSearchParams();

  if (isAuthenticated) {
    if (searchParams.get("redirectPath")) {
      return <Navigate to={searchParams.get("redirectPath")} replace />;
    }

    return (
      <Navigate
        to={isWebMaintenance ? PATHS.maintenance.root : getPathAfterLogin(user?.role)}
        replace
      />
    );
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
